// Auto Free Shipping Discount Application
document.addEventListener('DOMContentLoaded', () => {
  initAutoFreeShipping();
});

function initAutoFreeShipping() {
  // Configuration
  const FREE_SHIPPING_THRESHOLD = 20000; // $200.00 in cents
  const FREE_SHIPPING_DISCOUNT_CODE = 'FREESHIP200'; // Discount code to apply

  // Monitor cart changes
  document.addEventListener('cart:refresh', handleCartUpdate);
  document.addEventListener('cart:updated', handleCartUpdate);

  // Initial check
  handleCartUpdate();
}

async function handleCartUpdate() {
  try {
    // Get current cart
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    const FREE_SHIPPING_THRESHOLD = 20000; // $200.00 in cents
    const FREE_SHIPPING_DISCOUNT_CODE = 'FREESHIP200';

    // Check if cart total meets free shipping threshold
    if (cart.total_price >= FREE_SHIPPING_THRESHOLD) {
      // Check if free shipping discount is already applied
      const hasDiscountApplied = cart.cart_level_discount_applications?.some(
        discount => discount.title?.toLowerCase().includes('free shipping') ||
                   discount.title?.toLowerCase().includes('freeship')
      );

      if (!hasDiscountApplied) {
        // Apply free shipping discount code
        await applyFreeShippingDiscount(FREE_SHIPPING_DISCOUNT_CODE);
      }
    }
  } catch (error) {
    console.log('Auto free shipping check failed:', error);
  }
}

async function applyFreeShippingDiscount(discountCode) {
  try {
    // Method 1: Try using the built-in discount form if it exists
    const discountForm = document.querySelector('cart-discount form, form[action*="discount"]');
    if (discountForm) {
      const discountInput = discountForm.querySelector('input[name="discount"]');
      const submitButton = discountForm.querySelector('button[type="submit"], input[type="submit"]');

      if (discountInput && submitButton) {
        discountInput.value = discountCode;
        submitButton.click();
        console.log('Free shipping discount applied via form');
        return;
      }
    }

    // Method 2: Direct API approach (if supported)
    const response = await fetch('/discount/' + discountCode, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      }
    });

    if (response.ok) {
      console.log('Free shipping discount applied via API');
      // Refresh cart to show updated totals
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }
  } catch (error) {
    console.log('Could not auto-apply free shipping discount:', error);
  }
}

// Export for potential manual use
window.applyFreeShippingDiscount = applyFreeShippingDiscount;